import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { addNotification } from 'modules/notifications/redux';
import { NotificationTypes } from 'modules/notifications';
import { ExclusionZonesApi } from '../api';
import { ExclusionZoneActions } from '../redux';
import { ExclusionZoneForm } from '../types';

export const useCreateOrUpdateExclusionZone = (
  onSuccess: () => void,
): {
  loading: boolean;
  handleUpdateOrCreate: (values: ExclusionZoneForm) => Promise<void>;
} => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleUpdateOrCreate = useCallback(
    async (values: ExclusionZoneForm) => {
      setLoading(true);
      try {
        const returnedZone = values.id
          ? await ExclusionZonesApi.updateExclusionZone(values)
          : await ExclusionZonesApi.createExclusionZone(values);
        dispatch(ExclusionZoneActions.setExclusionZones([returnedZone]));
        dispatch(
          addNotification({
            type: NotificationTypes.Success,
            message: `Exclusion zone has been ${
              values.id ? 'updated' : 'created'
            } successfully.`,
          }),
        );
        onSuccess();
      } catch (err) {
        dispatch(
          addNotification({
            type: NotificationTypes.Error,
            message: `Error while ${
              values.id ? 'updating' : 'creating a'
            } exclusion zone.`,
          }),
        );
      } finally {
        setLoading(false);
      }
    },
    [dispatch, onSuccess],
  );

  return {
    loading,
    handleUpdateOrCreate,
  };
};
